import React, { useContext, useEffect, useState } from 'react'

export const OfertasQuincesCmp = ({ofertasquinces, addOferta} ) => {

    function handlerSeleccion(oferta) {
        addOferta(oferta);  
    }
    return (
        <div>
            <h1 className="text-2xl font-bold mb-10">Toque en la oferta que desee</h1>
            {ofertasquinces.map((item) => (
                <div style={{ borderWidth: 2 }} key={item.oferta} className="card w-100 shadow-xl mb-5 ">
                    <div  className="card-body">
                        {item.precio == '150 USD' ? <div className="justify-end"><span className="badge badge-secondary">Mas popular</span></div>: null}
                        <h2 className="card-title">{item.precio}</h2>
                        <p>{item.oferta}</p>
                        <div className="card-actions justify-end">
                            <button className="btn btn-primary" onClick={()=>handlerSeleccion(item)}>Seleccionar</button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}
